module.exports = __webpack_public_path__ + "static/media/popover-edit.9158cbf9.svg";